import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1643ed30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-bespoke-inflammatory-response" }
const _hoisted_2 = { class: "hd-bespoke-inflammatory-response__container" }
const _hoisted_3 = { class: "hd-bespoke-inflammatory-response__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_overlay_module = _resolveComponent("overlay-module")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lyra_asset, {
      class: "hd-title",
      "asset-key": `${_ctx.endpointId}.title`
    }, null, 8, ["asset-key"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "hd-bespoke-inflammatory-response__chart",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processOverlay('image')))
      }, [
        _createVNode(_component_base_image_svg, {
          class: "hd-bespoke-inflammatory-response__chart-plus",
          source: require(`!html-loader!@/ui/assets/icons/control-point.svg`)
        }, null, 8, ["source"]),
        _createVNode(_component_base_image_svg, {
          isImage: "",
          source: require('@/applications/covid-hub/ui/assets/bespoke/inflammatory-response-image.png')
        }, null, 8, ["source"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_lyra_asset, {
          class: "hd-text",
          "asset-key": `${_ctx.endpointId}.bottom.text`
        }, null, 8, ["asset-key"])
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_ctx.overlay === 'image')
          ? (_openBlock(), _createBlock(_component_overlay_module, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_base_image_svg, {
                  isImage: "",
                  class: "overlay-chart-image",
                  source: require('@/applications/covid-hub/ui/assets/bespoke/inflammatory-response-image.png')
                }, null, 8, ["source"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}